import {
  AGENT_MONTH_CARD_TITLE,
  AGENT_MONTH_CARD_TITLE_GENERIC,
} from "@bash/shared";
import { useTaskStore } from "@/stores/taskStore";
import { useTeamStore } from "@/stores/teamStore";

/**
 * The title of a used-up agent month's card (agent wallet, spec 2026-10-15),
 * read off the task's own `agentId`: none is Bash; one the roster knows is that
 * agent (its lead row is Bash); one it can't place yet (the roster loads async,
 * and only with the agents flag on) gets the neutral title. Bash's name never
 * goes on a teammate's month.
 */
export function useAgentMonthTitle(taskId: string | null | undefined): string {
  const agentId = useTaskStore((s) =>
    taskId ? (s.tasks.get(taskId)?.agentId ?? null) : null
  );
  const agent = useTeamStore((s) =>
    agentId ? (s.agents.find((a) => a.id === agentId) ?? null) : null
  );
  if (!agentId) return AGENT_MONTH_CARD_TITLE("Bash");
  if (!agent) return AGENT_MONTH_CARD_TITLE_GENERIC;
  return AGENT_MONTH_CARD_TITLE(agent.kind === "agent" ? agent.name : "Bash");
}
